"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetUserCountQuery = exports.usersApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var statsBaseQuery_1 = require("../../utils/statsBaseQuery");
exports.usersApi = (0, react_1.createApi)({
    reducerPath: "usersApi",
    baseQuery: (0, statsBaseQuery_1.statsBaseQuery)("userApi", process.env.STATS_USER_API, process.env.STATS_API_TOKEN),
    tagTypes: ["users"],
    endpoints: function (builder) { return ({
        getUserCount: builder.query({
            query: function (region) { return ({ region: region, url: "/v2/client/users?status=ACTIVE&size=1&imported=false&role=USER" }); },
            transformResponse: function (response) { var _a, _b; return (_b = (_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0; },
            providesTags: ["users"],
        }),
    }); },
});
exports.useGetUserCountQuery = exports.usersApi.useGetUserCountQuery;
